import React from 'react'
import { priceFormat } from '../../exports/UtilFunctions'
import { getDeviceSize } from '../../exports/InteractiveUtils';

const DEVICE_SIZE = getDeviceSize()

const ConfirmationTable = ({
    successData = [],
    failedData = [],
    transferData = [],
    purchaseMessage='',
}) => {
    const mergedSuccess = mergeTransactionData(successData, transferData);
    const mergedFailed = mergeTransactionData(failedData, transferData);

    console.log(mergedSuccess)

    return (
        <div className="transaction-results-card">
            {mergedSuccess.length > 0 && (
                <div className="swift-mf-popup-body">
                    <h3 className="results-title">Successful Transactions</h3>
                    <p style={{ fontSize: "12px" }}>{purchaseMessage}</p>

                    <div className="mf-BuySell-container">
                        {DEVICE_SIZE === "S" ? (
                            mergedSuccess.map((transaction, index) => (
                                <ConfirmationCard key={index} transaction={transaction} />
                            ))
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <td className="scheme-name">Scheme Name</td>
                                        <td style={{ textAlign: "center" }}>Order Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mergedSuccess.map((transaction, index) => (
                                        <tr key={index}>
                                            <td>{transaction.scheme_name}</td>
                                            <td style={{ textAlign: "center" }}>
                                                {priceFormat(transaction.display_amount)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            )}

            {mergedFailed.length > 0 && (
                <div className="swift-mf-popup-body">
                    <h3 className="results-title">Failed Transactions</h3>

                    <div className="mf-BuySell-container">
                        {DEVICE_SIZE === "S" ? (
                            mergedFailed.map((transaction, index) => (
                                <ConfirmationCard key={index} transaction={transaction} fail />
                            ))
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <td>Scheme Name</td>
                                        <td style={{ textAlign: "center" }}>Order Amount</td>
                                        <td>Remark</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mergedFailed.map((transaction, index) => (
                                        <tr key={index}>
                                            <td>{transaction.scheme_name}</td>
                                            <td style={{ textAlign: "center" }}>
                                                {priceFormat(transaction.display_amount)}
                                            </td>
                                            <td>{transaction.trxn_remark || transaction.reg_remark || transaction.can_remark || "Unknown error"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

function ConfirmationCard({ transaction, fail }) {
    const {
        scheme_name,
        SchemeName,
        display_amount,
        trxn_remark,
        reg_remark,
        can_remark
    } = transaction

    return (
        <div className="mf-watchlist-card">
            <div className="mfwc-info">
                <p className="name">{scheme_name || SchemeName || "N/A"}</p>
                <p className="confirm">
                    Order Amount:&nbsp;<span>{priceFormat(display_amount)}</span>
                </p>
                {fail && (
                    <p className="confirm">
                        Remarks:&nbsp;<span>{trxn_remark || reg_remark || can_remark || "Unknown error"}</span>
                    </p>
                )}
            </div>
        </div>
    )
}

export default ConfirmationTable

// 🔑 merge logic here
const mergeTransactionData = (statusData, transferData) => {
    return statusData.map((trxn, index) => {
        const matchingTransfer = transferData[index] ||
            transferData.find(t =>
                (t.folio_no && t.folio_no === trxn.folio_no) ||
                ((t.isin || t.ISIN) && (t.isin || t.ISIN) === trxn.isin) ||
                (t.scheme_code && t.scheme_code === trxn.scheme_code) ||
                (t.xsip_reg_no && t.xsip_reg_no === trxn.xsip_reg_no)
            );

        // calculate actual amount for "All Units"
        let displayAmount = trxn.order_amount;
        if (trxn.all_units === "Y" && matchingTransfer) {
            const units = parseFloat(matchingTransfer.units || 0);
            const nav = parseFloat(matchingTransfer.current_nav || 0);
            displayAmount = units * nav;
        }

        return {
            ...trxn,
            ...(matchingTransfer || {}),
            scheme_name: matchingTransfer?.scheme_name || matchingTransfer?.Scheme_Name || trxn.scheme_name || matchingTransfer?.SchemeName || "N/A",
            display_amount: matchingTransfer.order_amount || trxn.installment_amount || matchingTransfer.Amount || displayAmount ||  0
        };
    });
};
